export type StepConfig = {
  path: string;
  private?: boolean;
  requirements?: StepRequirement[];
  relativePath?: boolean;
};

export type FlowConfig = Record<string, StepConfig>;

export interface FlowMap {
  hybrid: FlowConfig;
  bundleSelection: FlowConfig;
  unknown: FlowConfig;
}

export enum FlowType {
  Pc = 'hybrid',
  Printer = 'bundleSelection',
  Unknown = 'unknown',
}

export type StepParams = {
  pdpConfig?: { skus: string; pdpFlow: string; isSMB?: string };
  cart?: { id: string };
  claim?: { cartId: string };
  orderComplete?: { id: string };
  [key: string]: Record<string, string> | undefined;
};

export type StepRequirement =
  | 'hasIISubscription'
  | 'isLoggedIn'
  | 'redirectToClaim'
  | 'hasMoreThanOneTenant';

export type Requirements = Record<StepRequirement, boolean>;
